export const managementTranslations = {
  title: 'BiteCritic Management',
  dashboard: 'Dashboard',
  users: 'User Management',
  settings: 'Settings',
  foods: {
    title: 'Food Management',
    createNew: 'Add New Food',
    id: 'ID',
    name: 'Name',
    category: 'Category',
    country: 'Country',
    status: 'Status',
    createdAt: 'Created At',
    actions: 'Actions',
    noFoodsFound: 'No foods found',
    searchPlaceholder: 'Search foods...',
    allStatuses: 'All Statuses',
    allCategories: 'All Categories',
    sortNewest: 'Newest First',
    sortOldest: 'Oldest First',
    sortNameAZ: 'Name A-Z',
    sortNameZA: 'Name Z-A',
    showing: 'Showing {{from}} to {{to}} of {{total}} foods',
    confirmDelete: 'Are you sure you want to delete this food?',
    approve: 'Approve',
    reject: 'Reject',
    createFood: 'Create New Food',
    editFood: 'Edit Food',
    viewFood: 'View Food Details',
    namePlaceholder: 'Enter food name',
    descriptionPlaceholder: 'Enter food description',
    selectCategory: 'Select a category',
    selectCountry: 'Select a country',
    selectStatus: 'Select a status',
    imageUrl: 'Image URL',
    imageUrlPlaceholder: 'Enter image URL',
    imagePreview: 'Image Preview',
    rowsPerPage: '{{count}} per page',
    translations: 'Translations',
    description: 'Description',
    formatJson: 'Format JSON',
    jsonPlaceholder: 'Enter food data in JSON format',
    jsonInstructions: 'JSON Format Instructions',
    jsonInstructionName: 'Name is required and must be a string',
    jsonInstructionCategory: 'CategoryId is required and must be a number',
    jsonInstructionCountry: 'CountryId is optional and must be a number',
    jsonInstructionStatus: 'Status must be one of',
    jsonInstructionTranslations:
      'Translations should be a record of language codes to translation objects',
    jsonUpdateError: 'Error updating {{field}}: {{error}}',
    hideFilters: 'Hide Filters',
    showFilters: 'Show Filters',
    totalItems: '{{count}} items total',
    aiPrompt: {
      title: 'Generate Food Data with AI',
      description: 'Use AI to help generate food data',
      inputLabel: 'Food Name',
      inputPlaceholder: 'Enter a food name',
      buttonText: 'Generate with AI',
      copyPrompt: 'Copy Prompt',
      openInChatGPT: 'Open in ChatGPT',
      promptCopied: 'Prompt copied to clipboard!',
      instructions: 'Instructions:',
      step1: '1. Enter a food name',
      step2: '2. Click "Generate with AI" or copy the prompt',
      step3: '3. Paste the prompt into ChatGPT or click "Open in ChatGPT"',
      step4: '4. Copy the JSON response and use it to create a new food item',
    },
  },
  languages: {
    en: 'English',
    nl: 'Dutch',
    tr: 'Turkish',
    de: 'German',
    fr: 'French',
    es: 'Spanish',
    it: 'Italian',
    pt: 'Portuguese',
  },
};

export type ManagementTranslations = typeof managementTranslations;

export default managementTranslations;
